import SizeSelector from '@/components/shared/SizeSelector';
import { ExpandIcon, CropIcon } from '@/components/icons';
import useStyles from './ViewControls.styles';

import type { SizeValue } from '@/components/shared/SizeSelector';

interface ViewControlsProps {
  viewCrop: boolean;
  viewSize: SizeValue;
  onCropToggle: () => void;
  onSizeChange: (size: SizeValue) => void;
}

export const ViewControls = ({
  viewCrop,
  viewSize,
  onCropToggle,
  onSizeChange,
}: ViewControlsProps) => {
  const classes = useStyles();

  return (
    <div className={classes.viewControls}>
      {/* Crop/Expand toggle - always active since it's a state toggle */}
      <button
        type="button"
        className={`${classes.viewOptionButton} ${classes.viewOptionButtonActive}`}
        onClick={onCropToggle}
        title={viewCrop ? 'Show natural aspect ratio' : 'Crop to squares'}
        aria-label={viewCrop ? 'Show natural aspect ratio' : 'Crop to squares'}
      >
        {viewCrop ? (
          <ExpandIcon className={classes.viewOptionIcon} />
        ) : (
          <CropIcon className={classes.viewOptionIcon} />
        )}
      </button>
      {/* Size selector dropdown */}
      <SizeSelector value={viewSize} onChange={onSizeChange} />
    </div>
  );
};
